// Loom — Static fallback data.
//
// In a configured Shopify store, snippets/loom-data-bootstrap.liquid runs
// FIRST and populates window.LOOM_* from product variants + metaobjects.
// This file then only fills in defaults for anything Shopify hasn't set —
// so the site never breaks even mid-setup.
//
// Single source of truth in production: Shopify admin
//   - Product "Loom — Parfums" + 36 variants (one per gusto)
//   - Vessel products (Cornet, Gobelet, Bac) with vessel.* metafields
//   - Metaobject "trio" (curated combos)
// See SHOPIFY_SETUP.md for the visual setup walkthrough.
//
// Flavor schema (LOOM_FLAVORS entries):
//   id:        kebab-case identifier matching the variant SKU
//   fr:        display name in French
//   cat:       'glace' | 'sorbet'        — category (NR-2 shows on every tile)
//   tags:      string[]                  — mood chips ("gourmand", "fruité"…)
//   color:     hex string                — primary scoop fill
//   ink:       hex string                — readable text color on `color`
//   swirl:     hex string                — accent swirl
//   note:      string                    — short ingredient hint
//   allergens: string[] (OPTIONAL)       — NR-8 structure. Add per-flavor:
//                                          ['lait', 'gluten', 'fruits-coque', …]
//                                          Empty by default; team fills via
//                                          Shopify metafield `flavor.allergens`
//                                          or directly here.

window.LOOM_FLAVORS = window.LOOM_FLAVORS && window.LOOM_FLAVORS.length ? window.LOOM_FLAVORS : [
  // === GLACES (dairy) ===
  { id: 'caramel-sale',     fr: 'Caramel salé',        cat: 'glace',  tags:['gourmand','classique'],         color:'#D4A164', ink:'#432918', swirl:'#FFF075', note:'beurre salé de Bretagne' },
  { id: 'cannelle',         fr: 'Cannelle',            cat: 'glace',  tags:['épicé','classique'],            color:'#C88A5C', ink:'#432918', swirl:'#FFF075', note:'cannelle de Ceylan' },
  { id: 'chocolat',         fr: 'Chocolat',            cat: 'glace',  tags:['chocolaté','classique'],        color:'#5C3623', ink:'#FFF2DA', swirl:'#432918', note:'Équateur 72%' },
  { id: 'cinnamon-roll',    fr: 'Cinnamon Roll',       cat: 'glace',  tags:['gourmand','épicé'],             color:'#E6B98A', ink:'#432918', swirl:'#C88A5C', note:'morceaux de brioche' },
  { id: 'chocolat-piment',  fr: 'Chocolat piment',     cat: 'glace',  tags:['chocolaté','audacieux'],        color:'#6B2A1A', ink:'#FFF2DA', swirl:'#EA5A24', note:"piment d'Espelette" },
  { id: 'eau-de-rose',      fr: 'Eau de rose',         cat: 'glace',  tags:['floral','audacieux'],           color:'#F5C6CD', ink:'#432918', swirl:'#EE7BAE', note:'pétales distillés' },
  { id: 'bacio',            fr: 'Bacio',               cat: 'glace',  tags:['chocolaté','gourmand'],         color:'#8B5A3C', ink:'#FFF2DA', swirl:'#432918', note:'chocolat-noisette' },
  { id: 'amarena',          fr: 'Amarena',             cat: 'glace',  tags:['fruité','classique'],           color:'#C44848', ink:'#FFF2DA', swirl:'#EA565D', note:'cerises Fabbri' },
  { id: 'cacahuetes',       fr: 'Cacahuètes',          cat: 'glace',  tags:['gourmand','salé'],              color:'#D4A164', ink:'#432918', swirl:'#8A5A1F', note:'torréfiées maison' },
  { id: 'moka',             fr: 'Moka',                cat: 'glace',  tags:['café','classique'],             color:'#6B4423', ink:'#FFF2DA', swirl:'#432918', note:'arabica éthiopien' },
  { id: 'menthe-chocolat',  fr: 'Menthe chocolat',     cat: 'glace',  tags:['herbacé','chocolaté'],          color:'#B5D4B0', ink:'#432918', swirl:'#432918', note:'menthe poivrée · pépites' },
  { id: 'noisettes-pecan',  fr: 'Noisettes pécan',     cat: 'glace',  tags:['gourmand','fruitsec'],          color:'#C8A072', ink:'#432918', swirl:'#8A5A1F', note:'noisettes IGP · pécans' },
  { id: 'noix-de-coco',     fr: 'Noix de coco',        cat: 'glace',  tags:['exotique','classique'],         color:'#F8ECD8', ink:'#432918', swirl:'#FFF2DA', note:'coco râpée fraîche' },
  { id: 'pistache-kulfi',   fr: 'Pistache kulfi',      cat: 'glace',  tags:['fruitsec','exotique'],          color:'#A8BC7A', ink:'#432918', swirl:'#DDE7AD', note:'cardamome · lait condensé' },
  { id: 'fior-di-latte',    fr: 'Fior di Latte',       cat: 'glace',  tags:['classique','lacté'],            color:'#FFF2DA', ink:'#432918', swirl:'#FDECE6', note:'lait vaudois entier' },
  { id: 'matcha',           fr: 'Matcha',              cat: 'glace',  tags:['herbacé','audacieux'],          color:'#8FB04A', ink:'#FFF2DA', swirl:'#DDE7AD', note:"matcha d'Uji cérémonie" },
  { id: 'stracciatella',    fr: 'Stracciatella',       cat: 'glace',  tags:['classique','chocolaté'],        color:'#FFF2DA', ink:'#432918', swirl:'#432918', note:'copeaux de cacao 70%' },
  { id: 'speculoos',        fr: 'Spéculoos',           cat: 'glace',  tags:['gourmand','épicé'],             color:'#C88A5C', ink:'#432918', swirl:'#8A5A1F', note:'biscuits belges' },
  { id: 'tonka',            fr: 'Fève tonka',          cat: 'glace',  tags:['audacieux','floral'],           color:'#D8BC8C', ink:'#432918', swirl:'#8A5A1F', note:'tonka du Venezuela' },
  { id: 'yaourt',           fr: 'Yaourt',              cat: 'glace',  tags:['lacté','acidulé'],              color:'#FDECE6', ink:'#432918', swirl:'#FFF2DA', note:'yaourt de brebis' },
  { id: 'vanille',          fr: 'Vanille',             cat: 'glace',  tags:['classique','lacté'],            color:'#FFF075', ink:'#432918', swirl:'#FFF2DA', note:'gousses de Madagascar' },
  { id: 'yuzu',             fr: 'Yuzu',                cat: 'glace',  tags:['acidulé','exotique'],           color:'#FDC100', ink:'#432918', swirl:'#FFF075', note:'agrume japonais' },
  { id: 'praline',          fr: 'Praliné',             cat: 'glace',  tags:['gourmand','fruitsec'],          color:'#B5814A', ink:'#FFF2DA', swirl:'#D4A164', note:'amandes caramélisées' },
  { id: 'pistache-salee',   fr: 'Pistache salée',      cat: 'glace',  tags:['fruitsec','salé'],              color:'#DDE7AD', ink:'#432918', swirl:'#8FB04A', note:'Bronte DOP · fleur de sel' },
  { id: 'sesame-noir',      fr: 'Sésame noir',         cat: 'glace',  tags:['audacieux','fruitsec'],         color:'#4A4240', ink:'#FFF2DA', swirl:'#8A5A1F', note:'graines torréfiées' },

  // === SORBETS (vegan, fruit) ===
  { id: 'citron-vert',      fr: 'Citron vert',         cat: 'sorbet', tags:['acidulé','frais'],              color:'#DDE7AD', ink:'#432918', swirl:'#DDE7AD', note:'lime de Perse' },
  { id: 'chocolat-sorbet',  fr: 'Chocolat (sorbet)',   cat: 'sorbet', tags:['chocolaté','vegan'],            color:'#432918', ink:'#FFF2DA', swirl:'#5C3623', note:'cacao pur · sans lait' },
  { id: 'fraise',           fr: 'Fraise',              cat: 'sorbet', tags:['fruité','classique'],           color:'#EE7BAE', ink:'#432918', swirl:'#F5C6CD', note:'fraises du Valais' },
  { id: 'gingembre',        fr: 'Gingembre',           cat: 'sorbet', tags:['épicé','audacieux'],            color:'#FDC100', ink:'#432918', swirl:'#FFF075', note:'racine fraîche râpée' },
  { id: 'framboise',        fr: 'Framboise',           cat: 'sorbet', tags:['fruité','acidulé'],             color:'#EA565D', ink:'#FFF2DA', swirl:'#EE7BAE', note:'Villeneuve · juin-août' },
  { id: 'lait-de-coco',     fr: 'Lait de coco',        cat: 'sorbet', tags:['exotique','vegan'],             color:'#FFF2DA', ink:'#432918', swirl:'#F8ECD8', note:'crème de coco Sri Lanka' },
  { id: 'banane',           fr: 'Banane',              cat: 'sorbet', tags:['fruité','exotique'],            color:'#FFF075', ink:'#432918', swirl:'#EBE000', note:'bananes bio équitables' },
  { id: 'baies-de-bois',    fr: 'Baies des bois',      cat: 'sorbet', tags:['fruité','audacieux'],           color:'#8B4A7A', ink:'#FFF2DA', swirl:'#B87BB3', note:'mûre · myrtille · cassis' },
  { id: 'cassis',           fr: 'Cassis',              cat: 'sorbet', tags:['fruité','acidulé'],             color:'#6B2A5C', ink:'#FFF2DA', swirl:'#B87BB3', note:'baies de Bourgogne' },
  { id: 'passion',          fr: 'Passion',             cat: 'sorbet', tags:['exotique','acidulé'],           color:'#FDC100', ink:'#432918', swirl:'#EA5A24', note:'maracujá jaune' },
  { id: 'mangue',           fr: 'Mangue',              cat: 'sorbet', tags:['exotique','fruité'],            color:'#EA5A24', ink:'#FFF2DA', swirl:'#FDC100', note:"Alphonso d'Inde" },
];

// Tag palette — for mood-chip filtering
window.LOOM_TAGS = window.LOOM_TAGS && window.LOOM_TAGS.length ? window.LOOM_TAGS : [
  { id: 'classique',  label: 'Classiques' },
  { id: 'chocolaté',  label: 'Chocolaté' },
  { id: 'fruité',     label: 'Fruité' },
  { id: 'exotique',   label: 'Exotique' },
  { id: 'audacieux',  label: 'Audacieux' },
  { id: 'fruitsec',   label: 'Fruits secs' },
  { id: 'acidulé',    label: 'Acidulé' },
  { id: 'floral',     label: 'Floral' },
  { id: 'herbacé',    label: 'Herbacé' },
  { id: 'épicé',      label: 'Épicé' },
  { id: 'gourmand',   label: 'Gourmand' },
  { id: 'salé',       label: 'Salé' },
  { id: 'vegan',      label: 'Vegan' },
];

// Vessels with CHF pricing (fallback only — Shopify products are source of truth)
window.LOOM_VESSELS = window.LOOM_VESSELS && window.LOOM_VESSELS.length ? window.LOOM_VESSELS : [
  { id: 'cornet1',    handle: 'coupe-cornet-1-boule',    label: 'Cornet 1 parfum',  short:'Cornet 1', capacity: 1, price: 3.50 },
  { id: 'cornet2',    handle: 'coupe-cornet-2-boules',   label: 'Cornet 2 parfums', short:'Cornet 2', capacity: 2, price: 6.00 },
  { id: 'mini',       handle: 'coupe-mini-gobelet',      label: 'Mini gobelet',     short:'Mini',     capacity: 2, price: 4.00 },
  { id: 'petit',      handle: 'coupe-petit-gobelet',     label: 'Petit gobelet',    short:'Petit',    capacity: 3, price: 6.00 },
  { id: 'moyen',      handle: 'coupe-gobelet-moyen',     label: 'Gobelet moyen',    short:'Moyen',    capacity: 3, price: 9.00 },
  /* Per i bac: `capacity` è il MAX scoops che il cliente può scegliere (sempre 4
     — decisione prodotto: niente più di 4 gusti per bac). `volumeKey` è invece
     la grandezza VISIVA del contenitore (S=3, M=4, L=5, XL=6) — keya LOOM_TUB_SIZES
     che renderizza la vaschetta nella size corretta. Disaccopliamo capacità
     scoops da volume del bac per poter avere bac grandi con poche palle generose. */
  { id: 'bacS',       handle: 'coupe-bac-s',             label: 'Bac S · 500 ml',   short:'Bac S',    capacity: 4, volumeKey: 3, price: 20.00, ml: 500,  persons: '3-4' },
  { id: 'bacM',       handle: 'coupe-bac-m',             label: 'Bac M · 750 ml',   short:'Bac M',    capacity: 4, volumeKey: 4, price: 28.00, ml: 750,  persons: '5-6' },
  { id: 'bacL',       handle: 'coupe-bac-l',             label: 'Bac L · 1000 ml',  short:'Bac L',    capacity: 4, volumeKey: 5, price: 36.00, ml: 1000, persons: '7-8' },
  { id: 'bacXL',      handle: 'coupe-bac-xl',            label: 'Bac XL · 1500 ml', short:'Bac XL',   capacity: 4, volumeKey: 6, price: 55.00, ml: 1500, persons: '10-12' },
];

// Vessel families for the family picker (fallback only)
window.LOOM_VESSEL_FAMILIES = window.LOOM_VESSEL_FAMILIES && Object.keys(window.LOOM_VESSEL_FAMILIES).length ? window.LOOM_VESSEL_FAMILIES : {
  cornet:  ['cornet1','cornet2'],
  gobelet: ['mini','petit','moyen'],
  bac:     ['bacS','bacM','bacL','bacXL'],
};

// Pairings — when you add X, tray highlights these (fallback only)
window.LOOM_PAIRINGS = window.LOOM_PAIRINGS && Object.keys(window.LOOM_PAIRINGS).length ? window.LOOM_PAIRINGS : {
  'pistache-salee': ['chocolat','fior-di-latte','amarena'],
  'pistache-kulfi': ['framboise','chocolat','fior-di-latte'],
  'chocolat':       ['pistache-salee','framboise','noisettes-pecan','menthe-chocolat'],
  'fior-di-latte':  ['amarena','pistache-salee','chocolat','fraise'],
  'vanille':        ['chocolat','caramel-sale','framboise','amarena'],
  'caramel-sale':   ['chocolat','vanille','cacahuetes'],
  'matcha':         ['yuzu','fraise','lait-de-coco'],
  'yuzu':           ['matcha','passion','gingembre'],
  'fraise':         ['fior-di-latte','chocolat','vanille'],
  'framboise':      ['chocolat','pistache-kulfi','vanille'],
  'mangue':         ['passion','lait-de-coco','citron-vert'],
  'passion':        ['mangue','yuzu','lait-de-coco'],
  'eau-de-rose':    ['pistache-salee','framboise','amarena'],
  'sesame-noir':    ['matcha','yuzu','chocolat'],
};

// Curated "Surprise me" trios (fallback — Shopify metaobjects override this)
window.LOOM_TRIOS = window.LOOM_TRIOS && window.LOOM_TRIOS.length ? window.LOOM_TRIOS : [
  { name: 'Le Lausannois',  ids: ['fior-di-latte','pistache-salee','amarena'],     tag: 'classique italien' },
  { name: 'Le Téméraire',   ids: ['chocolat-piment','eau-de-rose','sesame-noir'],  tag: 'audacieux' },
  { name: 'Le Tropical',    ids: ['mangue','passion','lait-de-coco'],              tag: 'sorbet vegan' },
  { name: 'Le Goûter',      ids: ['chocolat','noisettes-pecan','caramel-sale'],    tag: 'gourmand' },
  { name: 'Le Jardin',      ids: ['matcha','yuzu','framboise'],                    tag: 'herbacé' },
  { name: "L'Enfance",      ids: ['vanille','fraise','chocolat'],                  tag: 'classique' },
];

// Ranges (homepage section — managed by section blocks in Theme Editor, this is JS fallback)
window.LOOM_RANGES = window.LOOM_RANGES && window.LOOM_RANGES.length ? window.LOOM_RANGES : [
  { id: 'ice',  label: 'Ice Cream',  word: 'flow', fr: 'Glaces',      bg: '#F5C6CD', ink: '#432918' },
  { id: 'choc', label: 'Choco Bar',  word: 'wow',  fr: 'Bâtonnets',   bg: '#EA5A24', ink: '#FFF2DA' },
  { id: 'nap',  label: 'Napolitain', word: 'glow', fr: 'Napolitains', bg: '#FDC100', ink: '#432918' },
  { id: 'mac',  label: 'Macaron',    word: 'fun',  fr: 'Macarons',    bg: '#DEC8E2', ink: '#432918' },
];

// Tub size presets keyed by capacity. Pure visual config — never sourced from Shopify.
window.LOOM_TUB_SIZES = window.LOOM_TUB_SIZES || {
  3: { w: 280, h: 220, rectW: 220, rectH: 150, rimY: 60, labelW: 170, labelH: 110, ml: '500 ml' },
  4: { w: 320, h: 230, rectW: 260, rectH: 160, rimY: 60, labelW: 200, labelH: 115, ml: '750 ml' },
  5: { w: 360, h: 245, rectW: 300, rectH: 175, rimY: 60, labelW: 230, labelH: 125, ml: '1000 ml' },
  6: { w: 400, h: 260, rectW: 340, rectH: 190, rimY: 60, labelW: 260, labelH: 135, ml: '1500 ml' },
};

/* ===========================================================================
   FLAVOR LIFECYCLE — how staff manage flavors WITHOUT touching code.

   Same UI staff already know: PRODUCTS + INVENTORY tabs. No metaobjects,
   no concepts new to learn. One Shopify product `Loom — Parfums` holds the
   catalog; each variant on that product = one flavor.

   A) DISABLE a flavor (sold-out today)
      Admin → Products → Inventory tab.
      Find the flavor row → set the quantity column to 0 → Save.
      Result: tile greys out + labelled "Indisponible" + non-clickable.

   B) RE-ENABLE a flavor
      Same screen → bump the quantity above 0 → Save.

   C) BULK disable (e.g. all sorbets for today)
      Inventory tab → multi-select the rows → bulk-edit quantity to 0.
      ~10 seconds for as many flavors as needed.

   D) ADD a special / seasonal flavor
      Products → Loom — Parfums → Add variant.
      Required fields:
        - Option1 value  → display name in French (e.g. "Mango Habanero")
        - SKU            → kebab-case id (e.g. "mango-habanero") — used by JS
        - Inventory      → "Track quantity" ON · "Continue selling…" OFF
                           + initial quantity > 0
      Then click into the variant → Metafields panel:
        - flavor.color     (color picker — ONE colour, rest auto)
        - flavor.category  ("glace" or "sorbet")
      Optional metafields:
        - flavor.note      ("citron du Mendoza")
        - flavor.tags      (list — mood chips: "fruité", "audacieux"…)
        - flavor.allergens (list — "lait", "fruits-coque"…)
        - flavor.ink, flavor.swirl (color overrides; usually leave empty)
      Save → the flavor appears in the catalog on next page load.

   E) PERMANENTLY REMOVE a flavor
      Products → Loom — Parfums → click variant → Delete.

   AUTOMATIC COLOR DERIVATION
   Only `flavor.color` is required. The system computes the rest:
     - `ink`   = readable text color on the tile (dark on light, cream on dark)
     - `swirl` = accent swirl — same hue, ±30% luminance
   Override only if the auto-derived swirl looks off — `flavor.ink` and
   `flavor.swirl` metafields win over the auto values when set.

   PRIORITY ORDER (when a flavor id exists in multiple places)
     1. Shopify product variant (PRIMARY — staff edits here)
     2. Hardcoded fallback in loom-data.js below (SEED — 36 base flavors)
     3. window.LOOM_FLAVORS_UNAVAILABLE list (shop metafield) → marks any
        id as unavailable regardless of source.
   =========================================================================== */

(function () {
  function hex2rgb(hex) {
    var c = String(hex || '').replace('#', '');
    if (c.length === 3) c = c[0]+c[0]+c[1]+c[1]+c[2]+c[2];
    if (c.length !== 6) return null;
    var n = parseInt(c, 16);
    return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
  }
  function rgb2hex(r, g, b) {
    function h(n) { return ('0' + Math.max(0, Math.min(255, n)).toString(16)).slice(-2); }
    return '#' + h(r) + h(g) + h(b);
  }
  function luminance(rgb) {
    // YIQ perceptual luminance (0..255).
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
  }

  // Brand defaults — match tokens.css --marrone and --cream.
  var INK_DARK  = '#432918';
  var INK_LIGHT = '#FFF2DA';

  function deriveInk(hexColor) {
    var rgb = hex2rgb(hexColor);
    if (!rgb) return INK_DARK;
    return luminance(rgb) >= 140 ? INK_DARK : INK_LIGHT;
  }
  function deriveSwirl(hexColor) {
    var rgb = hex2rgb(hexColor);
    if (!rgb) return '#000000';
    // Light colors → darker swirl. Dark colors → lighter swirl. ~32% shift.
    var factor = luminance(rgb) >= 140 ? 0.65 : 1.42;
    return rgb2hex(
      Math.round(rgb.r * factor),
      Math.round(rgb.g * factor),
      Math.round(rgb.b * factor)
    );
  }

  // Expose helpers so callers (cup-builder.js, future themes) can re-use them.
  window.LOOM_COLORS = { deriveInk: deriveInk, deriveSwirl: deriveSwirl };

  // Shopify variants are the SOURCE OF TRUTH for the catalog.
  //
  // If the bootstrap emitted LOOM_FLAVORS_ADDITIONS (= the loom-parfums product
  // has at least one variant), the hardcoded fallback above is REPLACED with
  // the Shopify list — so deleting a variant in admin removes it from the site.
  //
  // For each Shopify variant we still merge with the matching fallback entry
  // (when id matches) so the classic flavors keep their hand-crafted colors
  // even when the variant only emits `{id, fr, available}` from the bootstrap.
  //
  // Priority for each field:
  //   1. Value present on the Shopify variant (metafield or computed) — WINS
  //   2. Value from the hardcoded fallback below — fills missing fields
  //   3. Auto-derived (ink, swirl) — if still missing after (1) and (2)
  //
  // For a NEW special (id not in fallback) the variant MUST have `color` set,
  // otherwise the code has nothing to draw with and we skip it.
  if (Array.isArray(window.LOOM_FLAVORS_ADDITIONS) && window.LOOM_FLAVORS_ADDITIONS.length) {
    var fallbackById = {};
    window.LOOM_FLAVORS.forEach(function (f) { fallbackById[f.id] = f; });

    window.LOOM_FLAVORS = window.LOOM_FLAVORS_ADDITIONS.map(function (variant) {
      if (!variant || !variant.id) return null;
      var fb = fallbackById[variant.id];
      if (fb) {
        // Merge fallback as base + variant overrides on top.
        var merged = {};
        for (var k in fb) {
          if (Object.prototype.hasOwnProperty.call(fb, k)) merged[k] = fb[k];
        }
        for (var k2 in variant) {
          if (Object.prototype.hasOwnProperty.call(variant, k2) && variant[k2] !== undefined) {
            merged[k2] = variant[k2];
          }
        }
        return merged;
      }
      // No fallback for this id — it's a NEW special. Needs color to render.
      if (variant.color) return variant;
      return null;
    }).filter(Boolean);
  }
  // else: no Shopify variants at all — keep the hardcoded fallback as safety net.

  // Finalize: fill missing ink/swirl on every flavor (works for both bootstrap
  // entries and the hardcoded fallback). Hand-curated values are preserved.
  window.LOOM_FLAVORS.forEach(function (f) {
    if (!f.color) return;
    if (!f.ink)   f.ink   = deriveInk(f.color);
    if (!f.swirl) f.swirl = deriveSwirl(f.color);
    if (f.available !== false) f.available = true;
  });
})();
